module.exports = __webpack_public_path__ + "static/vampire_spawn_2-4e42d27a7ad239f4a4190ea5f889426c.jpg";